import React from 'react';
import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import ProfileDetails from './profileDetails';
import Engagements from './engagements';
import Collections from './collections';
import KeyInsightDetails from './keyInsightDetails';
import Recommended from './recommended';
import useProfilePanel from './useProfilePanel';
import * as styles from './styles';

function ProfilePanel({ onSync, onManageSubscription }) {
    const { profileDisplay, collections, recommendedPublishers } = useProfilePanel();

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                <Typography sx={styles.eyebrow}>
                    Manage My ECAL · My profile
                </Typography>
                <Typography sx={styles.heading}>
                    Hello,{' '}
                    <Box component="span" sx={styles.headingGradient}>
                        {profileDisplay.firstName || 'there'}
                    </Box>
                </Typography>
                <Typography sx={styles.subheading}>
                    Your ECAL profile, your connection, and your collection — at a glance.
                </Typography>
            </Box>
        );
    }

    function renderTopRow() {
        return (
            <Box sx={styles.topRow}>
                <ProfileDetails
                    displayName={profileDisplay.displayName}
                    email={profileDisplay.email}
                    avatarInitials={profileDisplay.avatarInitials}
                    personaType={profileDisplay.personaType}
                    role={profileDisplay.role}
                    city={profileDisplay.city}
                    country={profileDisplay.country}
                    timezone={profileDisplay.timezone}
                    connectedDevices={profileDisplay.connectedDevices}
                />
                {/* TODO: re-enable when engagement data is ready
                <Engagements
                    score={profileDisplay.engagementScore}
                    total={profileDisplay.engagementTotal}
                    pct={profileDisplay.engagementPct}
                    rankingPublisher={profileDisplay.rankingPublisher}
                    rankingCountry={profileDisplay.rankingCountry}
                    rankingCountryName={profileDisplay.rankingCountryName}
                    rankingWorld={profileDisplay.rankingWorld}
                />
                */}
            </Box>
        );
    }

    function renderMiddleRow() {
        return (
            <Box sx={styles.middleRow}>
                <Collections publishers={collections} onSelectPublisher={onManageSubscription} />
                {/* TODO: re-enable when insight data is ready
                <KeyInsightDetails
                    eventsThisMonth={profileDisplay.eventsThisMonth}
                    timeBooked={profileDisplay.timeBookedLabel}
                    percentOfMonth={profileDisplay.scheduleDensityPct}
                />
                */}
            </Box>
        );
    }

    return (
        <Box>
            {renderHeader()}
            {renderTopRow()}
            {renderMiddleRow()}
            <Box sx={styles.recommendedRow}>
                <Recommended publishers={recommendedPublishers} onSync={onSync} />
            </Box>
        </Box>
    );
}

export default observer(ProfilePanel);
